import OrderableModel from '@/models/OrderableModel';

export default class TablePreset extends OrderableModel {
    get route () {
        return 'table-presets';
    }

    static get className () {
        return 'TablePreset';
    }

    static get isInStore () {
        return true;
    }
}
